import { gql, TypedDocumentNode } from "@apollo/client";

export interface RevokeAgentToolPermissionGrantMutation {
  revokeAgentToolPermissionGrant: {
    ok: boolean | null;
  } | null;
}

export interface RevokeAgentToolPermissionGrantMutationVariables {
  uuid: string;
}

export const REVOKE_AGENT_TOOL_PERMISSION_GRANT: TypedDocumentNode<
  RevokeAgentToolPermissionGrantMutation,
  RevokeAgentToolPermissionGrantMutationVariables
> = gql`
  mutation RevokeAgentToolPermissionGrant($uuid: String!) {
    revokeAgentToolPermissionGrant(uuid: $uuid) {
      ok
    }
  }
`;
